import { ref, computed, watch, useTemplateRef } from 'vue';
import type MessageBuilder from '~/components/general/message-builder/MessageBuilder.vue';
import debounce from '~/utils/debounce';

export function useMessageBuilderInModal() {
    const messageBuilderRef = useTemplateRef<InstanceType<typeof MessageBuilder>>('messageBuilder');

    const stacked = computed(() => {
        if (!messageBuilderRef.value) {
            return false;
        }
        return messageBuilderRef.value.modalOpen;
    });

    const uploadingMedia = computed(() => Boolean(messageBuilderRef.value?.uploadingMedia));

    const preventClosing = ref(false);

    watch(
        [() => messageBuilderRef.value?.emojisPicker, () => messageBuilderRef.value?.actionsDropdown],
        debounce(() => {
            preventClosing.value = Boolean(
                messageBuilderRef.value?.emojisPicker || messageBuilderRef.value?.actionsDropdown
            );
        }, 150)
    );

    return {
        stacked,
        uploadingMedia,
        preventClosing,
    };
}
